export default __webpack_public_path__ + "static/media/title-banner.18dc1657.png";